
const digest = '498b9e8fe45d0a127f792cc4d87635c46a72e73f77a1979415b2625b79477595';
const classes = {"panel":"_panel_1h9z8_1"};
const css = `._panel_1h9z8_1 {
  min-height: 100%;
  padding: 28px 30px;
  background-color: var(--md-white);
  border: 1px solid var(--md-color-border-light);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  